import { ElementRef } from '@angular/core';
import { RRLinkModel } from '../../common/models/link.model';

export interface RRLayoutsModel {
  headline?: string;
  text?: string;
  link?: RRLinkModel;
  class?: string;
  list?: RRLayoutsModel[];
  template?: ElementRef;
  disabled?: boolean;
  hide?: boolean;
}
